/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import _has from 'lodash/has';
import { ISolidFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { IPropValue, ITDColor, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { ICTSRgbColor } from '@tencent/slide-sdk-model';

export class GradientStop implements IPropValue {
    public pos: number;
    public color: ITDColor;

    public constructor(pos: number, color: string|TDColor) {
        this.pos = Math.min(Math.max(pos, 1), 100);
        if (typeof color === 'string') {
            this.color = new TDColor({ rgbaStr: color });
        }
        if (color instanceof TDColor) {
            this.color = color;
        }
    }

    public toPropValue(): any {
        return {
            pos: this.pos,
            color: this.color.toPropValue(),
        };
    }
}

export interface IColorTransform {
    lumMod?: number;
    lumOff?: number;
    tint?: number;
    shade?: number;
}

export interface IFillToRect {
    b: number,
    l: number,
    r: number,
    t: number,
}
export interface IGradientPath {
    path: string,
    fillToRct?: IFillToRect,
}
export interface IGradientLin {
    ang: number;
    scale: number;
}
export class BaseFill implements IPropValue {
    public toPropValue(): any { }
    public clone(): BaseFill {
        return new BaseFill();
    }
}
export class SolidFill extends BaseFill implements ISolidFill {
    public color: TDColor;

    // todo: 构造函数不太合理，重构成参数对象
    public constructor(
        colorStr?: string | TDColor,
        srgbClr?: DeepReadonly<DeepPartial<ICTSRgbColor>>,
    ) {
        super();
        if (srgbClr) {
            this.color = new TDColor({ srgbClr });
        } else if (colorStr) {
            if (colorStr instanceof TDColor) {
                this.color = colorStr;
            } else {
                this.color = new TDColor({ rgbaStr: colorStr });
            }
        }
    }

    public toPropValue() {
        return {
            solidFill: this.color.toPropValue(),
        };
    }

    public clone() {
        return new SolidFill(this.color);
    }
}
export class ImageFill extends BaseFill {
    private src: string;
    private stretch: any;

    public constructor(src?: string) {
        super();
        if (src) {
            this.src = src;
        }
    }
}

export class GradientFill extends BaseFill {
    public gsList: Array<GradientStop> = [];

    public lin: IGradientLin;

    public pathGradient: IGradientPath;

    public rotateWithShape: any; // TODO 应该是bool型，需要确认一下

    public constructor(gsList?: any) {
        super();
        if (gsList instanceof Array) {
            for (const gs of gsList) {
                if (_has(gs, 'pos') && typeof gs.pos === 'number' && _has(gs, 'color')) {
                    if (typeof gs.color === 'string') {
                        this.addGradientStop(new GradientStop(gs.pos, gs.color));
                    } else if (typeof gs.color.srgb_color === 'string') {
                        this.addGradientStop(new GradientStop(gs.pos, new TDColor({ rgbaStr: gs.color.srgb_color })));
                    }
                }
            }
        }
    }

    public addGradientStop(gs: GradientStop) {
        this.gsList.push(gs);
    }
}

